function Logo(props) {
  return <img alt="Logo" src="/static/logo_black.png" {...props} />;
}

export default Logo;
